import { useState, useEffect, useMemo } from 'react';
import { useFetch } from 'hooks';
import { Charts, ContentWrapper, SelectMenu, NoRecord } from 'components/generic';
import { analyticsColors, analyticsActionsList, doughnutConfig, channelStatisticsAnalytics, actionStatisticsAnalytics } from 'config';
import { sumBy } from 'lodash';
import { getValuesById, textFormatter } from 'utils';
import './style.scss';
const colors = ['#81b577', '#f58787'];

const Analytics = () => {
	const [analyticsData, setAnalyticsData] = useState(null);
	const [batchDateList, setBatchDateList] = useState([]);
	const [selectedBatch, setSelectedBatch] = useState(null);
	const [hideAnalytics, setHideAnalytics] = useState(true);
	const api = useFetch();

	const fetchAnalytics = async bd_batchID => {
		const { data } = await api({ url: 'analytics/v1', method: 'post', data: { bd_batchID } });
		const chartData = {
			communicationMedium: [],
			callbackLaterCount: [],
			paymentPlanCount: [],
			paynowCount: [],
			totalCommunications: [],
			totalDelivered: [],
			totalFailed: [],
			totalNotVisited: [],
			totalVisited: [],
			actionCompleted: [],
			actionNotCompleted: [],
			callbackLaterNotActionedCount: [],
			paymentPlanNotActionedCount: [],
			paynowNotActionedCount: []
		};

		setHideAnalytics(data?.data?.length === 0);

		if (data?.data?.length) {
			data?.data?.map(el => {
				Object.keys(chartData)?.map(elm => chartData[elm]?.push(el[elm]));
			});

			chartData.communicationMedium = chartData?.communicationMedium?.map(el => textFormatter(el));

			const list = { actionCompleted: [], actionNotCompleted: [] };
			chartData?.communicationMedium?.forEach((elm, i) => {
				console.log(elm);
				list?.actionCompleted?.push([chartData?.totalVisited[i], chartData?.callbackLaterCount[i], chartData?.paymentPlanCount[i], chartData?.paynowCount[i]]);
				list?.actionNotCompleted?.push([chartData?.totalVisited[i], chartData?.callbackLaterNotActionedCount[i], chartData?.paymentPlanNotActionedCount[i], chartData?.paynowNotActionedCount[i]]);
			});

			chartData.actionCompleted = list?.actionCompleted;
			chartData.actionNotCompleted = list?.actionNotCompleted;
		}

		setAnalyticsData(chartData);
	};

	const batchListAPI = async () => {
		const { data } = await api({ url: 'analytics/v1/batchDates', method: 'get' });
		setBatchDateList(data?.data?.map(el => ({ key: el?.bd_batchID, value: el?.batchDate })));
		const firstBatch = data?.data?.at()?.bd_batchID;
		firstBatch ? setBatch(firstBatch) : setHideAnalytics(true);
	};

	const setBatch = e => {
		setSelectedBatch(e);
		fetchAnalytics(e);
	};

	useEffect(() => {
		batchListAPI();
	}, []);

	const channelStatistics = useMemo(() => {
		return (
			<>
				<div className='row'>
					<div className='col-4'>
						<ContentWrapper shadow>
							<div className='analytics__messages'>
								<h5>Total Messages Sent</h5>
								<div className='analytics__chart'>
									<Charts type='doughnut' data={{ labels: analyticsData?.communicationMedium, datasets: [{ data: analyticsData?.totalCommunications, backgroundColor: analyticsColors }] }} options={doughnutConfig} />
									<h4 className='chart__display'>{sumBy(analyticsData?.totalCommunications)}</h4>
								</div>
							</div>
						</ContentWrapper>
					</div>
					<div className='col-8'>
						<ContentWrapper shadow>
							<div className='analytics__messages'>
								<div className='space-between'>
									<h5>Delivered Status</h5>
									<ul className='legend flex-end'>
										<li className='align-center'>
											<span className='legend__icon' style={{ backgroundColor: colors[0] }}></span>Delivered
										</li>
										<li className='align-center'>
											<span className='legend__icon' style={{ backgroundColor: colors[1] }}></span>Failed
										</li>
									</ul>
								</div>
								<div className='analytics__chart'>
									<Charts
										type='bar'
										data={{
											labels: analyticsData?.communicationMedium,
											datasets: [
												{ data: analyticsData?.totalDelivered, backgroundColor: colors[0], borderRadius: 5, barThickness: 30, maxBarThickness: 30 },
												{ data: analyticsData?.totalFailed, backgroundColor: colors[1], borderRadius: 5, barThickness: 30, maxBarThickness: 30 }
											]
										}}
										options={channelStatisticsAnalytics}
									/>
								</div>
							</div>
						</ContentWrapper>
					</div>
				</div>
				<div className='row'>
					<div className='col-8'>
						<ContentWrapper shadow>
							<div className='analytics__messages'>
								<div className='space-between'>
									<h5>Channel-Wise Statistics</h5>
									<ul className='legend flex-end'>
										<li className='align-center'>
											<span className='legend__icon' style={{ backgroundColor: colors[0] }}></span>Opened
										</li>
										<li className='align-center'>
											<span className='legend__icon' style={{ backgroundColor: colors[1] }}></span>Not Opened
										</li>
									</ul>
								</div>
								<div className='analytics__chart'>
									<Charts
										type='bar'
										data={{
											labels: analyticsData?.communicationMedium,
											datasets: [
												{ data: analyticsData?.totalVisited, backgroundColor: colors[0], borderRadius: 5, barThickness: 30, maxBarThickness: 30 },
												{ data: analyticsData?.totalNotVisited, backgroundColor: colors[1], borderRadius: 5, barThickness: 30, maxBarThickness: 30 }
											]
										}}
										options={channelStatisticsAnalytics}
									/>
								</div>
							</div>
						</ContentWrapper>
					</div>
					<div className='col-4'>
						<ContentWrapper shadow>
							<div className='analytics__messages'>
								<h5>DSS Link Access Through</h5>
								<div className='analytics__chart'>
									<Charts type='doughnut' data={{ labels: analyticsData?.communicationMedium, datasets: [{ data: analyticsData?.totalVisited, backgroundColor: analyticsColors }] }} options={doughnutConfig} />
									<h4 className='chart__display'>{sumBy(analyticsData?.totalVisited)}</h4>
								</div>
							</div>
						</ContentWrapper>
					</div>
				</div>
			</>
		);
	}, [analyticsData]);

	const featureAnalytics = useMemo(() => {
		return (
			<>
				<h3>Feature Analysis</h3>
				<div className='row'>
					<div className='col-6'>
						<ContentWrapper shadow>
							<div className='analytics__actions'>
								<div className='space-between'>
									<h5>Action Completed</h5>
									<ul className='legend flex-end'>
										{analyticsData?.communicationMedium?.map((el, i) => (
											<li key={i} className='align-center'>
												<span className='legend__icon' style={{ backgroundColor: analyticsColors[i] }}></span>
												{textFormatter(el)}
											</li>
										))}
									</ul>
								</div>
								<div className='analytics__feature'>
									<Charts
										type='bar'
										data={{
											labels: analyticsActionsList?.map(el => textFormatter(el?.key)),
											datasets: [
												{ data: analyticsData?.actionCompleted?.[0], backgroundColor: analyticsColors[0], borderRadius: 5, barThickness: 30, maxBarThickness: 30 },
												{ data: analyticsData?.actionCompleted?.[1], backgroundColor: analyticsColors[1], borderRadius: 5, barThickness: 30, maxBarThickness: 30 },
												{ data: analyticsData?.actionCompleted?.[2], backgroundColor: analyticsColors[2], borderRadius: 5, barThickness: 30, maxBarThickness: 30 }
											]
										}}
										options={actionStatisticsAnalytics}
									/>
								</div>
							</div>
						</ContentWrapper>
					</div>
					<div className='col-6'>
						<ContentWrapper shadow>
							<div className='analytics__actions'>
								<div className='space-between'>
									<h5>Action Not Completed</h5>
									<ul className='legend flex-end'>
										{analyticsData?.communicationMedium?.map((el, i) => (
											<li key={i} className='align-center'>
												<span className='legend__icon' style={{ backgroundColor: analyticsColors[i] }}></span>
												{textFormatter(el)}
											</li>
										))}
									</ul>
								</div>
								<div className='analytics__feature'>
									<Charts
										type='bar'
										data={{
											labels: analyticsActionsList?.map(el => textFormatter(el?.key)),
											datasets: [
												{ data: analyticsData?.actionNotCompleted?.[0], backgroundColor: analyticsColors[0], borderRadius: 5, barThickness: 30, maxBarThickness: 30 },
												{ data: analyticsData?.actionNotCompleted?.[1], backgroundColor: analyticsColors[1], borderRadius: 5, barThickness: 30, maxBarThickness: 30 },
												{ data: analyticsData?.actionNotCompleted?.[2], backgroundColor: analyticsColors[2], borderRadius: 5, barThickness: 30, maxBarThickness: 30 }
											]
										}}
										options={actionStatisticsAnalytics}
									/>
								</div>
							</div>
						</ContentWrapper>
					</div>
				</div>
			</>
		);
	}, [analyticsData]);

	return (
		<>
			<div className='space-between'>
				<h3>Channel Analysis</h3>
				<div className='analytics__dates'>
					<SelectMenu menuOptions={batchDateList || []} placeholder='Batch Dates' value={getValuesById(batchDateList, selectedBatch)} onChange={setBatch} />
				</div>
			</div>
			{!hideAnalytics && (
				<>
					{channelStatistics}
					{featureAnalytics}
				</>
			)}
			{hideAnalytics && <NoRecord header='No data found for the selected batch!' description='Please contact your Admin' height='calc(100% - 70px)' />}
		</>
	);
};

export default Analytics;
